var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".menu_svg__st0{fill:none;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "menu_svg__st0",
    d: "M23 21H1M23 3H1M21 12H1"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "m17 16 6-4-6-4"
  }));
};
export default SvgMenu;